import {Produto} from './produto.model';

export class ItemPedido {
    constructor(public produto: Produto, 
                public quantidade: number = 1){}

    total(): number {
        return this.produto.preco_atacado * this.quantidade;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/item-pedido.model.ts